// @ai-generated 2026-08-21T00:00:00Z by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import type { ReactToolCallRenderer } from '@copilotkit/react-core/v2';
import classes from './ChatWorkflowToolCallCard.module.css';
import { ToolCallCardShell } from './ToolCallCardShell';
import { resolveWorkflowToolStatus } from './workflowToolStatus';
import { WORKFLOW_TOOLS, type WorkflowTool } from './workflowTools';

function WorkflowToolCallCard({ tool, result, status }: { tool: WorkflowTool; result: unknown; status: unknown }) {
    const { state, report } = resolveWorkflowToolStatus(status, result);

    return (
        <ToolCallCardShell
            title={tool.title}
            state={state}
            result={result}
            {...(report !== undefined ? { body: <p className={classes.report}>{report}</p> } : {})}
        />
    );
}

/** Spread before the wildcard fallback, like the record-listing cards. */
export const ChatWorkflowToolCallCards: ReactToolCallRenderer[] = WORKFLOW_TOOLS.map((tool) => ({
    name: tool.name,
    render: ({ result, status }) => <WorkflowToolCallCard tool={tool} result={result} status={status} />,
}));
